import { ShopifyEvents } from '../../types/shopify'
import { SHOPIFY_EVENTS } from '../../utils/constants'

export class ShopifyEditor {
  listeners: { [key in ShopifyEvents]?: any } = {}

  on(eventName: ShopifyEvents, listener: any): void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = []
    }
    document.addEventListener(SHOPIFY_EVENTS[eventName], listener)
    this.listeners[eventName].push(listener)
  }

  off(eventName: ShopifyEvents, removedListener: any): void {
    if (!this.listeners[eventName]) {
      return
    }
    document.removeEventListener(SHOPIFY_EVENTS[eventName], removedListener)
    this.listeners[eventName] = this.listeners[eventName].filter(
      listener => listener !== removedListener,
    )
  }

  destroy(): void {
    Object.keys(this.listeners).forEach(event => {
      this.listeners[event].forEach(listener => {
        this.off(event as ShopifyEvents, listener)
      })
    })
    this.listeners = {}
  }
}
